const links: Record<string, string> = {
  SZ: '/vakantie/groepsreizen',
  WG: '/wintersport/groepsreizen',
  BZ: '/nl/vakantie/groepsreizen',
  BW: '/nl/skivakantie/groepsreizen',
  FS: '/fr/vacances/sejours-en-groupe',
  FH: '/fr/ski/vacances-au-ski-en-groupe',
  FZ: '/vacances/groupes',
  FW: '/ski/groupes',
  DW: '',
  UW: '',
  QZ: '/solresor/resor/gruppresor',
  QW: '/skidresor/resesallskap/grupper',
  KZ: '/grupperejser',
  KW: '/skiferie/grupperejser',
  EZ: '/vakantie/rondreis',
  BE: '/vakantie/rondreis',
}

export function getGroupsLink(publicationCode: string): string {
  return links[publicationCode]
}
